<div id="footerdiv" class="" style="margin-left: 11px">
  <!--#181050- Block if browser is not compatible to SSO AMS -->

  <footer style="margin-top: 15px">
    <p class="ng-binding">© {{ getYear }} - Chubb E-placement℠ System</p>
  </footer>
</div>
